export const createAuthorizationHeader = (sessionToken: string) =>
  `Bearer ${sessionToken}`;

export type ExtractTypename<T, U> = T extends { __typename?: U } ? T : never;

export type RecursivePartial<T> = {
  [P in keyof T]?: RecursivePartial<T[P]> | null;
};
